var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.6415 7.37015L6.59626 2.53906C6.51339 2.45891 6.4148 2.3953 6.30618 2.35189C6.19756 2.30848 6.08105 2.28613 5.96338 2.28613C5.8457 2.28613 5.72919 2.30848 5.62057 2.35189C5.51195 2.3953 5.41336 2.45891 5.3305 2.53906C5.16448 2.69926 5.07129 2.91598 5.07129 3.14188C5.07129 3.36777 5.16448 3.58449 5.3305 3.74469L9.74283 8.02L5.3305 12.2526C5.16448 12.4128 5.07129 12.6295 5.07129 12.8554C5.07129 13.0813 5.16448 13.298 5.3305 13.4582C5.41305 13.539 5.5115 13.6033 5.62014 13.6473C5.72877 13.6913 5.84544 13.7142 5.96338 13.7147C6.08131 13.7142 6.19798 13.6913 6.30662 13.6473C6.41525 13.6033 6.5137 13.539 6.59626 13.4582L11.6415 8.62709C11.7319 8.54702 11.8042 8.44984 11.8535 8.34168C11.9029 8.23351 11.9284 8.11671 11.9284 7.99862C11.9284 7.88054 11.9029 7.76373 11.8535 7.65557C11.8042 7.5474 11.7319 7.45022 11.6415 7.37015Z",
    fill: "#AC98F6"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.e2d8c86b1e8bdb6f52035d408690c9af.svg";
export { ForwardRef as ReactComponent };